/**
 * Модель заметки
 */
export class NoteModel {
    /**
     * Текст заметки
     */
    text: string = ""
    /**
     * Файлы, которые были прикреплены к заметке
     */
    files: NoteFileModel[] = [];
}
/**
 * Модель файла в заметке
 */
export class NoteFileModel {
    url: string = ""
}
export enum NoteActions {
    update,
    create
}
/**
 * Модель ивента, который возвращается с textarea
 */
export class NoteActionEventModel {
    note: NoteModel = new NoteModel();
    action: NoteActions = NoteActions.create;
}